import type { User } from '../../../utils/loginUtils'
import { getMessage } from '../../../utils/messageUtils'

import './UsersListEntry.scss'

interface UsersListEntryProps {
  user: User
  isMobile: boolean
  openPopup: (user: User | null) => void
}

function UsersListEntry({ user, isMobile, openPopup }: UsersListEntryProps) {
  const onClick = () => {
    openPopup(user)
  }
  return (
    <div
      key={user.username}
      className={`list-entry ${isMobile ? 'list-entry-mobile' : ''} ${user.admin ? 'list-entry-admin' : ''}`}
      onClick={onClick}
    >
      <div className="user-name">
        <span>{user.username}</span>
      </div>
      <div className="user-chat-id">
        <span>
          {user.telegram_chat_id ? `Chat ID: ${user.telegram_chat_id}` : ''}
        </span>
      </div>
      <div className="user-boolean">
        <span>{user.alerts ? getMessage('user_alerts_active') : ''}</span>
      </div>
      <div className="user-admin">
        <span>{user.admin ? getMessage('user_admin') : ''}</span>
      </div>
    </div>
  )
}

export default UsersListEntry
